import Util from "./util.js";
import tmObs from "./tmObs";

export default {
  convertObsSwStg,
  createDataSwStageValues,
  hasSwXsec,
  hasSwGraph,
  hasSwCamInfo,
};

// 内容コード無効時の観測値
const invalidVal = null;
// 内容コード無効時の表示文字列
const invalidStr = "-- ";
// 未収集 : 内容コード
const NOT_COLLECTED = 160;

//------------------------------------------------------------
/**
 * [危機管理水位観測所情報]表示データ作成
 * @param {*} obsData 危機管理水位観測所情報
 * @param {*} curtData 最新危機管理水位観測値情報
 * @param {*} min10Values [グラフ用]観測値リスト
 * @param {*} appTime 取得対象の時刻(yyyy/MM/dd HH:mm)
 */
function convertObsSwStg(obsData, curtData, min10Values, appTime) {
  if (
    obsData === undefined ||
    obsData === null ||
    obsData.obsInfo === undefined ||
    obsData.obsInfo === null
  ) {
    return {};
  }
  // 横断断面情報の加工
  if (Object.keys(obsData.crssct).length > 0) {
    for (var crsSct of obsData.crssct) {
      crsSct.drawHeight = crsSct.drawHigh;
    }
  }

  return {
    mtSwobs: obsData,
    obsInfo: createDataSwStgObsInfo(obsData),
    standardValue: createDataSwStgStandardValue(obsData),
    codeValue: createDataSwStgCodeValue(obsData),
    curt: createDataSwStgCurt(curtData, appTime),
    graph: createDataSwStageGraph(obsData, min10Values),
    obsValues: createDataStageValues(min10Values),
    swStg: min10Values,
    cctvInfo: {
      latestUrl: obsData.obsInfo.currProvUrl,
      usualUrl: obsData.obsInfo.normProvUrl,
      subLatestUrl: obsData.obsInfo.currentUrl,
      subUsualUrl: obsData.obsInfo.normallyUrl,
      liveUrl: obsData.obsInfo.liveUrl,
      camKind: obsData.obsInfo.camKind,
      sysId: obsData.obsInfo.sysId,
    },
    xsec: {
      stgobs: {
        crsFlg: obsData.obsInfo.crsFlg,
        drawType: obsData.obsInfo.drawType,
        leftBnkHghtLat: obsData.obsInfo.leftBnkLat,
        leftBnkHghtLon: obsData.obsInfo.leftBnkLon,
        rightBnkHghtLat: obsData.obsInfo.rightBnkLat,
        rightBnkHghtLon: obsData.obsInfo.rightBnkLon,
      },
      crs: {
        sfLeftLimit: obsData.crs.sfLeftLimit,
        sfRightLimit: obsData.crs.sfRightLimit,
        drawPosMax: obsData.crs.drawPosMax,
        drawPosMin: obsData.crs.drawPosMin,
        riverBed: obsData.crs.riverBed,
      },
    },
  };
}

/**
 * [危機管理水位観測所情報]
 * @param {*} obsData 危機管理水位観測所情報
 */
function createDataSwStgObsInfo(obsData) {
  if (
    obsData === undefined ||
    obsData === null ||
    obsData.obsInfo === undefined ||
    obsData.obsInfo === null
  ) {
    return [];
  }
  const info = obsData.obsInfo;
  let codeParam = "";
  if (info.swofcCd !== null && global.KWB_MODE === "admin") {
    codeParam = "  (事務所コード:" + info.swofcCd + ")";
  }

  return [
    {
      title: "管理者",
      value: Util.formatFloat(info.swofcNm),
      code: codeParam,
    },
    {
      title: "管理者(読み仮名)",
      value: info.swofcNmKana !== null ? info.swofcNmKana : invalidStr,
      notMb: true,
    },
    {
      title: "所在地",
      value: Util.formatFloat(info.addr),
    },
    {
      title: "所在地(読み仮名)",
      value: info.addrKana !== null ? info.addrKana : invalidStr,
      notMb: true,
    },
    {
      title: "緯度経度",
      value: tmObs.formatLatLon(info.lat, info.lon),
    },
  ];
}

/**
 * [危機管理水位観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataSwStgStandardValue(obsData) {
  if (
    obsData === undefined ||
    obsData === null ||
    obsData.obsInfo === undefined ||
    obsData.obsInfo === null
  ) {
    return [];
  }
  const info = obsData.obsInfo;
  return [
    {
      title: "氾濫開始水位",
      value: Util.formatFloat(info.fldStgHght, 2),
      unit: "m",
    },
    {
      title: "危険水位",
      value: Util.formatFloat(info.dngStgHght, 2),
      unit: "m",
    },
    {
      title: "観測開始水位",
      value: Util.formatFloat(info.strtStgHght, 2),
      unit: "m",
    },
  ];
}

/**
 * [危機管理水位観測所情報]
 * @param {*} obsData 観測所情報
 */
function createDataSwStgCodeValue(obsData) {
  if (
    obsData === undefined ||
    obsData === null ||
    obsData.obsInfo === undefined ||
    obsData.obsInfo === null
  ) {
    return [];
  }
  const info = obsData.obsInfo;
  // 管理者向けの時のみ
  if (global.KWB_MODE === "admin") {
    return [
      {
        title: "観測所コード",
        value: Util.formatFloat(info.swobsCd),
      },
      {
        title: "河川コード",
        value: Util.formatFloat(info.swrvrCd),
      },
      {
        title: "水系コード",
        value: Util.formatFloat(info.swrsysCd),
      },
    ];
  }
  return [];
}

/**
 * [危機管理水位観測所情報]
 * @param {*} curtData 最新危機管理水位観測値情報
 */
function createDataSwStgCurt(curtData) {
  return {
    // 内容コードを設定する
    swstgCcd: curtData != null ? 0 : NOT_COLLECTED,
    swstgOvlvl: curtData != null ? curtData.swstgOvlvl : null,
    stgHght:
      curtData != null ? Util.formatFloat(curtData.stgHght, 2) : invalidStr,
    obsTime:
      curtData != null ? tmObs.formatDateNonNull(curtData.obsTime) : invalidStr,
    isAbnrml: curtData != null ? curtData.stgQmFlg : null,
  };
}

/**
 * [危機管理水位観測所情報]
 * @param {*} obsData 観測所情報
 * @param {*} min10Values [グラフ用]観測値リスト
 */
function createDataSwStageGraph(obsData, min10Values) {
  if (
    obsData === undefined ||
    obsData === null ||
    obsData.obsInfo === undefined ||
    obsData.obsInfo === null ||
    obsData.crs === undefined ||
    obsData.crs === null
  ) {
    return [];
  }
  let min10mStg = null;

  // グラフ下限値を取得する
  for (var minCnt = 0; minCnt < min10Values.length; minCnt++) {
    if (min10Values[minCnt].stgHght !== null) {
      if (min10mStg === null) {
        min10mStg = min10Values[minCnt].stgHght;
      } else {
        if (min10mStg > min10Values[minCnt].stgHght) {
          min10mStg = min10Values[minCnt].stgHght;
        }
      }
    }
  }
  if (
    obsData.obsInfo.strtStg != null &&
    obsData.obsInfo.strtStgHght < min10mStg
  ) {
    min10mStg = obsData.obsInfo.strtStgHght;
  }

  let max = 1;
  // 最下位の値の小数点第一位を切り捨て
  let min = Math.floor(min10mStg);
  let max10mStgHght = null;
  // 観測値の最大値(堤防天端からの高さ)を取得する
  for (var maxCnt = 0; maxCnt < min10Values.length; maxCnt++) {
    if (min10Values[maxCnt].stgHght !== null) {
      if (max10mStgHght === null) {
        max10mStgHght = min10Values[maxCnt].stgHght;
      } else {
        if (max10mStgHght < min10Values[maxCnt].stgHght) {
          max10mStgHght = min10Values[maxCnt].stgHght;
        }
      }
    }
  }

  if (
    obsData.obsInfo.fldStg != null &&
    max10mStgHght < obsData.obsInfo.fldStgHght
  ) {
    max10mStgHght = obsData.obsInfo.fldStgHght;
  }

  // 最上位の値の小数点第一位を切り上げ
  max10mStgHght = Math.ceil(max10mStgHght);

  let dif = max10mStgHght - min;
  let quarter = dif / 4;

  if (quarter <= 0.5) {
    // <=0.5の場合は0.5
    quarter = 0.5;
  } else {
    // 0.5<の場合は（上下端差÷4の切り上げ整数)
    quarter = Math.ceil(quarter);
  }
  max = min + quarter * 4;

  // グラフデータ成形
  let graphData = {
    min10: {
      spec: {
        level: {
          max: max,
          flood:
            obsData.obsInfo.fldStg != null ? obsData.obsInfo.fldStgHght : null,
          danger:
            obsData.obsInfo.dngStg != null ? obsData.obsInfo.dngStgHght : null,
          start:
            obsData.obsInfo.strtStg != null
              ? obsData.obsInfo.strtStgHght
              : null,
          // min: tmObs.valueCeil(min10mStg - obsData.obsInfo.topendHght - 1.0, 1),
          min: min,
          title: "堤防天端からの高さ",
          unit: "m",
          obsCycl:
            obsData.obsInfo.obsCycl != null ? obsData.obsInfo.obsCycl : null,
        },
        prediction: 0,
      },
      value: [],
      stage: [],
    },
  };

  // 10分グラフデータ
  for (var i = min10Values.length - 1; 0 <= i; i--) {
    // 最大値/最小値格納
    graphData.min10.value.unshift({
      date: Util.formatDate24(min10Values[i].obsTime, "YYYY/MM/DD"),
      time: Util.formatDate24(min10Values[i].obsTime, "HH:mm"),
      level: min10Values[i].stg != null ? min10Values[i].stgHght : invalidVal,
    });

    graphData.min10.stage.unshift({
      date: Util.formatDate24(min10Values[i].obsTime, "YYYY/MM/DD"),
      time: Util.formatDate24(min10Values[i].obsTime, "HH:mm"),
      level: min10Values[i].stg != null ? min10Values[i].stgHght : invalidVal,
    });
  }

  return graphData;
}

/**
 * [危機管理水位観測所情報]
 * @param {*} min10Values [グラフ用]観測値リスト
 */
function createDataStageValues(min10Values) {
  // 観測値一覧データ成形
  let valuesData = {
    min10: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "20%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "20%",
        },
        {
          text: "堤防天端からの高さ[m]",
          align: "center",
          value: "stgLevel",
          width: "20%",
        },
      ],
      values: [],
      copyValues: [],
    },
  };

  // コピー用データのヘッダー追加
  valuesData.min10.copyValues.push(
    tmObs.getCopyHeader(valuesData.min10.headers)
  );

  let obsTime;
  let obsTimeBefore;
  // 10分観測値一覧データ
  for (var i = 0; i < min10Values.length; i++) {
    obsTime = Util.formatDate24(min10Values[i].obsTime, "MM/DD");

    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.min10.values.push({
      cd: i,
      date: obsTime,
      time: Util.formatDate24(min10Values[i].obsTime, "HH:mm"),
      stgLevel: Util.formatFloat(min10Values[i].stgHght, 2),
      swstgOvlvl: min10Values[i].swstgOvlvl,
      isAbnrml: min10Values[i].stgQmFlg != null && min10Values[i].stgQmFlg != 0,
    });

    let copyMin10Value =
      Util.formatDate24(min10Values[i].obsTime, "MM/DD") +
      "\t" +
      Util.formatDate24(min10Values[i].obsTime, "HH:mm") +
      "\t" +
      Util.formatFloat(min10Values[i].stgHght, 2);
    valuesData.min10.copyValues.push(copyMin10Value);

    obsTimeBefore = Util.formatDate24(min10Values[i].obsTime, "MM/DD");
    obsTime = "";
  }

  return valuesData;
}

/**
 * [危機管理水位観測所情報]
 * @param {*} minHrList 10分/時間毎の危機管理水位情報
 */
function createDataSwStageValues(swstg) {
  // 観測値一覧データ成形
  let valuesData = {
    min10: {
      headers: [
        {
          text: "日付",
          align: "center",
          value: "date",
          width: "20%",
        },
        {
          text: "時刻",
          align: "center",
          value: "time",
          width: "20%",
        },
        {
          text: "堤防天端からの高さ[m]",
          align: "center",
          value: "level",
          width: "20%",
        },
      ],
      values: [],
    },
  };

  let obsTime;
  let obsTimeBefore;
  // 観測値一覧データ
  for (var i = 0; i < swstg.length; i++) {
    obsTime = Util.formatDate24(swstg[i].obsTime, "MM/DD");
    if (obsTimeBefore === obsTime) {
      obsTime = "";
    }

    valuesData.min10.values.push({
      cd: i,
      date: obsTime,
      time: Util.formatDate24(swstg[i].obsTime, "HH:mm"),
      level: checkSwValid(swstg[i].stgHght, swstg[i].isValid, 2),
    });

    obsTimeBefore = Util.formatDate24(swstg[i].obsTime, "MM/DD");
    obsTime = "";
  }

  return valuesData;
}

/**
 * [危機管理水位]横断を表示するか
 * @param SelectedSw
 * @param min10Values
 * @return {boolean}
 */
function hasSwXsec(SelectedSw) {
  if (
    SelectedSw.mtSwobs === undefined ||
    SelectedSw.mtSwobs === null ||
    SelectedSw.mtSwobs.obsInfo === undefined ||
    SelectedSw.mtSwobs.obsInfo === null ||
    !SelectedSw.graph.min10.value.length
  ) {
    return false;
  }

  const swcrs = SelectedSw.mtSwobs.crs;
  const swStgObs = SelectedSw.mtSwobs.obsInfo;
  const drawType = SelectedSw.mtSwobs.obsInfo.drawType;
  const crsFlg = SelectedSw.mtSwobs.obsInfo.crsFlg;

  //横断非表示フラグでの判定
  if (crsFlg === 1) {
    return false;
  }

  // 左右岸の緯度経度が同じ場合は横断図は出力しない
  if (
    swStgObs.leftBnkLat === swStgObs.rightBnkLat &&
    swStgObs.leftBnkLon === swStgObs.rightBnkLon
  ) {
    return false;
  }

  // 横断表示フラグが横断ありの場合は描画する
  if (drawType === 1 || drawType === 2) {
    // 「横断マスタ、横断断面マスタ」または 「左右岸緯度経度」どちらか持っている場合は描画する
    if (hasSwStgXsec(swStgObs) || hasSwCrs(swcrs)) {
      return true;
    } else {
      return false;
    }
  }
  return false;
}

/**
 * [危機管理水位]水位グラフを表示するか
 * @param SelectedSw
 * @param min10Values
 * @return {boolean}
 */
function hasSwGraph(SelectedSw) {
  if (SelectedSw == undefined || SelectedSw.graph == undefined) {
    return false;
  }
  if (SelectedSw.graph.min10.value.length) {
    return true;
  }

  return false;
}

/**
 * [危機管理水位]左右岸緯度経度を持っているか
 * @param swStgobs
 * @return {boolean}
 */
function hasSwStgXsec(swStgobs) {
  if (swStgobs === undefined || swStgobs === null) {
    return false;
  }
  if (swStgobs.leftBnkLat === undefined || swStgobs.leftBnkLat === null) {
    return false;
  }
  if (swStgobs.leftBnkLon === undefined || swStgobs.leftBnkLon === null) {
    return false;
  }
  if (swStgobs.rightBnkLat === undefined || swStgobs.rightBnkLat === null) {
    return false;
  }
  if (swStgobs.rightBnkLon === undefined || swStgobs.rightBnkLon === null) {
    return false;
  }
  return true;
}

/**
 * [危機管理水位]横断マスタ、横断断面マスタを持っているか
 * @param crs
 * @return {boolean}
 */
function hasSwCrs(crs) {
  if (crs === undefined || crs === null) {
    return false;
  }
  if (crs.sfLeftLimit === undefined || crs.sfLeftLimit === null) {
    return false;
  }
  if (crs.sfRightLimit === undefined || crs.sfRightLimit === null) {
    return false;
  }
  return true;
}

/**
 * [危機管理水位]河川カメラ情報を持っているか
 * @param selectedSw
 * @return {boolean}
 */
function hasSwCamInfo(selectedSw) {
  if (
    selectedSw === undefined ||
    selectedSw === null ||
    selectedSw.mtSwobs === undefined ||
    selectedSw.mtSwobs === null ||
    selectedSw.mtSwobs.obsInfo === undefined ||
    selectedSw.mtSwobs.obsInfo === null
  ) {
    return false;
  }
  if (
    (selectedSw.mtSwobs.obsInfo.currProvUrl === undefined ||
      selectedSw.mtSwobs.obsInfo.currProvUrl === null) &&
    (selectedSw.mtSwobs.obsInfo.normProvUrl === undefined ||
      selectedSw.mtSwobs.obsInfo.normProvUrl === null) &&
    (selectedSw.mtSwobs.obsInfo.currentUrl === undefined ||
      selectedSw.mtSwobs.obsInfo.currentUrl === null) &&
    (selectedSw.mtSwobs.obsInfo.normallyUrl === undefined ||
      selectedSw.mtSwobs.obsInfo.normallyUrl === null)
  ) {
    return false;
  }
  return true;
}

//------------------------------------------------------------
/**
 *  [危機管理水位]データ有効無効チェック
 *
 * @param {?number} val1 数値
 * @param {?number} isValid データ有効無効フラグ
 * @param {number} digit 小数点有効桁数 (省略可能)
 * @returns {string} 内容コードを判断した結果の文字列
 */
function checkSwValid(val1, isValid, digit) {
  if (isValid === 0) {
    return invalidStr;
  } else {
    // val1 が null のときの処理は formatFloat() に含まれている
    return Util.formatFloat(val1, digit);
  }
}
